import React from 'react'
import { withRouter } from 'react-router-dom'
import { NavItem } from 'react-bootstrap'

class NavItemLinkWithoutRouter extends React.Component {
  handleLink = location => {
    this.props.history.push(location)
  }

  render() {
    const {
      to,
      children,
      history,
      location,
      match,
      staticContext,
      ...rest
    } = this.props
    return (
      <NavItem
        href={to.pathname || to}
        {...rest}
        onClick={() => this.handleLink(to)}
        children={children}
      />
    )
  }
}

const NavItemLink = withRouter(NavItemLinkWithoutRouter)
export default NavItemLink



// WEBPACK FOOTER //
// ./src/components/NavItemLink.js